angular.module('unergie.main')
.controller('managedAccountsCtrl', ($scope, $state, ModalService, TableGeneratorService, BoFeaturesService, DataAccess, AlertManager, ErrorCatcher) => {
    $scope.billingSuperAdmin = BoFeaturesService.isFeatureOn('billingSuperAdmin')

    $scope.managedAccounts = {
        show: {},
        refreshing: false,
        columns: {
            customer_id: { label: 'ID', mode: 'search_wildcard', length: 9 },
            id: { label: 'Id technique', mode: 'search_wildcard', visible: false, mandatory: true },
            organization: { label: 'Organisation', mode: 'search_wildcard' },
            brand: { label: 'Nom', mode: 'search_wildcard' },
            external_id: { label: 'Id. externe', mode: 'search_wildcard' },
            id_grd_contract: { label: 'Contrat GRD', mode: 'search_wildcard' },
            default_provider_offers: { label: 'Offres par défault surchargées', mode: 'hidden' },
            overrideElecOffers: { label: 'Surcharge des offres ELEC', mode: 'filter_only' },
            overrideGasOffers: { label: 'Surcharge des offres GAZ', mode: 'filter_only' },
        },
    }

    $scope.refresh = () => TableGeneratorService.getTable($scope.managedAccounts, 'managed-accounts', null, null, { orderBy: '-creation_ts' })

    $scope.openNewManagedAccountModal = () => {
        ModalService.openModal({ type: 'newManagedAccountModal', size: 'lg', backdrop: 'static' }, null, () => $scope.refresh())
    }

    $scope.openDefaultProviderOfferModal = (account, energy_type) =>
        ModalService.openModal({ type: 'defaultProviderOfferModal', size: 'md' },
            { energy_type, default_provider_offers: account.default_provider_offers ? account.default_provider_offers[energy_type] : {}, displayOverride: true },
            (defaultProviderOffers) => {
                console.log(`openDefaultProviderOfferModal default_provider_offers`, defaultProviderOffers)
                account.updating = true
                account.default_provider_offers = account.default_provider_offers ? account.default_provider_offers : {}
                account.default_provider_offers[energy_type] = defaultProviderOffers
                return DataAccess.updateManagedAccountDefaultProvOffer({ id: account.id }, { default_provider_offers: account.default_provider_offers }).$promise.then(() => {
                    AlertManager.success('Offres par défaut du marché modifiées')
                    $scope.refresh()
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    account.updating = false
                })
            })

    $scope.refresh()
})
